import styled from "styled-components"

import constants from "utils/constants"

import SVGIcon from "components/presenters/common/SVGIcon"

export default function StoreMoreBtn({ profileImg, brandName, vendorStoreLink }) {
  if (!profileImg || !brandName || !vendorStoreLink) return null
  return (
    <Block>
      <StoreExternalLink href={vendorStoreLink} target="_blank">
        <VendorInfoBlock>
          <ProfileImg src={`${constants.imagePath}/commerce/vendor/profile_img/${profileImg}`} />
          <BarText>{`${brandName} 더 알아보기`}</BarText>
        </VendorInfoBlock>
        <IconBlock>
          <SVGIcon name="arrow" />
        </IconBlock>
      </StoreExternalLink>
    </Block>
  )
}

const Block = styled.div`
  margin-bottom: calc(100vw * (26 / 375));
  background: #fffbf0;
  padding: calc(100vw * (13 / 375)) calc(100vw * (21 / 375)) calc(100vw * (14 / 375))
    calc(100vw * (12 / 375));
`

const StoreExternalLink = styled.a`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const VendorInfoBlock = styled.div`
  display: flex;
  align-items: center;
`

const ProfileImg = styled.img`
  width: calc(100vw * (35 / 375));
  height: calc(100vw * (35 / 375));
  border: 1px solid #efefef;
  border-radius: 100%;
  object-fit: cover;
  background-color: #fff;
  margin-right: calc(100vw * (10 / 375));
`

const BarText = styled.span`
  font-weight: 600;
  font-size: calc(100vw * (14 / 375));
  line-height: calc(100vw * (17 / 375));
  color: #e78a00;
`

const IconBlock = styled.div`
  width: calc(100vw * (6 / 375));
  height: calc(100vw * (10 / 375));

  svg {
    color: #e78a00;
  }
`
